"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.split");
var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _storeStatistics = require("@/api/order/storeStatistics");
var _shopList = require("@/api/shop/shopList");
var echarts = _interopRequireWildcard(require("echarts"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "门店统计",
  components: {},
  data: function data() {
    return {
      // 搜索表单数据
      searchForm: {
        regTimeRange: "",
        timeStart: "",
        timeEnd: "",
        areaIds: [],
        cityIds: [],
        storeIds: [],
        orderSaleTypes: [],
        packageFlag: null,
        timeSlots: []
      },
      regionOptions: [],
      storeList: [],
      areaOptions: [],
      timeSlotList: [],
      // 高级筛选显示状态
      showAdvanced: false,
      // 表格数据
      statisticData: {},
      revenueAndVolumeData: {},
      sceneStackData: {},
      // 加载状态
      loading: false,
      searchLoading: false,
      statisticsLoading: false,
      revenueAndVolumeLoading: false,
      sceneStackLoading: false,
      // 标签页相关
      activeTab: "list",
      // 当前激活的标签页
      editTabs: [],
      // 编辑标签页列表
      tabIndex: 0,
      // 标签页索引计数器
      imgPath: process.env.VUE_APP_IMAGE_PATH // 图片路径
    };
  },
  methods: {
    // 搜索功能
    handleSearch: function () {
      var _handleSearch = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var startTime, endTime, diffTime, diffDays, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.searchForm.regTimeRange && this.searchForm.regTimeRange.length === 2)) {
                _context.next = 1;
                break;
              }
              startTime = new Date(this.searchForm.regTimeRange[0]);
              endTime = new Date(this.searchForm.regTimeRange[1]);
              diffTime = endTime - startTime;
              diffDays = diffTime / (1000 * 60 * 60 * 24);
              if (!(diffDays > 31)) {
                _context.next = 1;
                break;
              }
              this.$message.warning('时间跨度不能超过 31 天');
              return _context.abrupt("return");
            case 1:
              this.searchLoading = true;
              _context.prev = 2;
              _context.next = 3;
              return Promise.all([this.getStoreStatistics(), this.getRevenueAndVolumeTrendsData(), this.getSceneStack()]);
            case 3:
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](2);
              console.error('搜索失败:', _t);
            case 5:
              _context.prev = 5;
              this.searchLoading = false;
              return _context.finish(5);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function handleSearch() {
        return _handleSearch.apply(this, arguments);
      }
      return handleSearch;
    }(),
    //获取信息
    getStoreStatistics: function () {
      var _getStoreStatistics = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.statisticsLoading = true;
              _context2.prev = 1;
              data = {}; // 处理时间范围数据
              if (this.searchForm.regTimeRange && this.searchForm.regTimeRange.length === 2) {
                data.timeStart = this.searchForm.regTimeRange[0];
                data.timeEnd = this.searchForm.regTimeRange[1];
              }

              // 处理多选字段，直接传递数组
              if (this.searchForm.areaIds && this.searchForm.areaIds.length > 0) {
                data.areaIds = this.searchForm.areaIds;
              }
              if (this.searchForm.cityIds && this.searchForm.cityIds.length > 0) {
                data.cityIds = this.searchForm.cityIds;
              }
              if (this.searchForm.storeIds && this.searchForm.storeIds.length > 0) {
                data.storeIds = this.searchForm.storeIds;
              }
              if (this.searchForm.orderSaleTypes && this.searchForm.orderSaleTypes.length > 0) {
                data.orderSaleTypes = this.searchForm.orderSaleTypes;
              }
              if (this.searchForm.packageFlag !== null && this.searchForm.packageFlag !== undefined) {
                data.packageFlag = this.searchForm.packageFlag;
              }
              // 处理时段数据，将时间范围字符串转换为对象数组
              if (this.searchForm.timeSlots && this.searchForm.timeSlots.length > 0) {
                data.timeSlots = [];
                this.searchForm.timeSlots.forEach(function (timeSlot) {
                  var _timeSlot$split = timeSlot.split('-'),
                    _timeSlot$split2 = (0, _slicedToArray2.default)(_timeSlot$split, 2),
                    start = _timeSlot$split2[0],
                    end = _timeSlot$split2[1];
                  var timeSlotStart = start.trim();
                  var timeSlotEnd = end.trim();

                  // 判断是否跨天（结束时间小于开始时间）
                  if (timeSlotStart > timeSlotEnd) {
                    // 跨天情况：分为两段 20:00-23:59 和 00:00-06:00
                    data.timeSlots.push({
                      timeSlotStart: timeSlotStart,
                      timeSlotEnd: '23:59'
                    });
                    data.timeSlots.push({
                      timeSlotStart: '00:00',
                      timeSlotEnd: timeSlotEnd
                    });
                  } else {
                    // 非跨天情况：正常处理
                    data.timeSlots.push({
                      timeSlotStart: timeSlotStart,
                      timeSlotEnd: timeSlotEnd
                    });
                  }
                });
              }
              _context2.next = 2;
              return (0, _storeStatistics.getOrderBaseData)(data);
            case 2:
              response = _context2.sent;
              if (response.code === 200) {
                this.statisticData = response.data || {};
              } else {
                this.$message.error(response.message || "获取失败");
              }
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
            case 4:
              _context2.prev = 4;
              this.statisticsLoading = false;
              return _context2.finish(4);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function getStoreStatistics() {
        return _getStoreStatistics.apply(this, arguments);
      }
      return getStoreStatistics;
    }(),
    getRevenueAndVolumeTrendsData: function () {
      var _getRevenueAndVolumeTrendsData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.revenueAndVolumeLoading = true;
              _context3.prev = 1;
              data = {}; // 处理时间范围数据
              if (this.searchForm.regTimeRange && this.searchForm.regTimeRange.length === 2) {
                data.timeStart = this.searchForm.regTimeRange[0];
                data.timeEnd = this.searchForm.regTimeRange[1];
              }

              // 处理多选字段，直接传递数组
              if (this.searchForm.areaIds && this.searchForm.areaIds.length > 0) {
                data.areaIds = this.searchForm.areaIds;
              }
              if (this.searchForm.cityIds && this.searchForm.cityIds.length > 0) {
                data.cityIds = this.searchForm.cityIds;
              }
              if (this.searchForm.storeIds && this.searchForm.storeIds.length > 0) {
                data.storeIds = this.searchForm.storeIds;
              }
              if (this.searchForm.orderSaleTypes && this.searchForm.orderSaleTypes.length > 0) {
                data.orderSaleTypes = this.searchForm.orderSaleTypes;
              }
              if (this.searchForm.packageFlag !== null && this.searchForm.packageFlag !== undefined) {
                data.packageFlag = this.searchForm.packageFlag;
              }
              // 处理时段数据，将时间范围字符串转换为对象数组
              if (this.searchForm.timeSlots && this.searchForm.timeSlots.length > 0) {
                data.timeSlots = [];
                this.searchForm.timeSlots.forEach(function (timeSlot) {
                  var _timeSlot$split3 = timeSlot.split('-'),
                    _timeSlot$split4 = (0, _slicedToArray2.default)(_timeSlot$split3, 2),
                    start = _timeSlot$split4[0],
                    end = _timeSlot$split4[1];
                  var timeSlotStart = start.trim();
                  var timeSlotEnd = end.trim();

                  // 判断是否跨天（结束时间小于开始时间）
                  if (timeSlotStart > timeSlotEnd) {
                    // 跨天情况：分为两段 20:00-23:59 和 00:00-06:00
                    data.timeSlots.push({
                      timeSlotStart: timeSlotStart,
                      timeSlotEnd: '23:59'
                    });
                    data.timeSlots.push({
                      timeSlotStart: '00:00',
                      timeSlotEnd: timeSlotEnd
                    });
                  } else {
                    // 非跨天情况：正常处理
                    data.timeSlots.push({
                      timeSlotStart: timeSlotStart,
                      timeSlotEnd: timeSlotEnd
                    });
                  }
                });
              }
              _context3.next = 2;
              return (0, _storeStatistics.getRevenueAndVolumeTrends)(data);
            case 2:
              response = _context3.sent;
              if (response.code === 200) {
                this.revenueAndVolumeData = response.data || {};
                // 数据加载完成后初始化图表
                this.initRevenueAndVolumeChart();
              } else {
                this.$message.error(response.message || "获取失败");
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
            case 4:
              _context3.prev = 4;
              this.revenueAndVolumeLoading = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function getRevenueAndVolumeTrendsData() {
        return _getRevenueAndVolumeTrendsData.apply(this, arguments);
      }
      return getRevenueAndVolumeTrendsData;
    }(),
    getSceneStack: function () {
      var _getSceneStack2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var data, response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.sceneStackLoading = true;
              _context4.prev = 1;
              data = {}; // 处理时间范围数据
              if (this.searchForm.regTimeRange && this.searchForm.regTimeRange.length === 2) {
                data.timeStart = this.searchForm.regTimeRange[0];
                data.timeEnd = this.searchForm.regTimeRange[1];
              }

              // 处理多选字段，直接传递数组
              if (this.searchForm.areaIds && this.searchForm.areaIds.length > 0) {
                data.areaIds = this.searchForm.areaIds;
              }
              if (this.searchForm.cityIds && this.searchForm.cityIds.length > 0) {
                data.cityIds = this.searchForm.cityIds;
              }
              if (this.searchForm.storeIds && this.searchForm.storeIds.length > 0) {
                data.storeIds = this.searchForm.storeIds;
              }
              if (this.searchForm.orderSaleTypes && this.searchForm.orderSaleTypes.length > 0) {
                data.orderSaleTypes = this.searchForm.orderSaleTypes;
              }
              if (this.searchForm.packageFlag !== null && this.searchForm.packageFlag !== undefined) {
                data.packageFlag = this.searchForm.packageFlag;
              }
              // 处理时段数据，将时间范围字符串转换为对象数组
              if (this.searchForm.timeSlots && this.searchForm.timeSlots.length > 0) {
                data.timeSlots = [];
                this.searchForm.timeSlots.forEach(function (timeSlot) {
                  var _timeSlot$split5 = timeSlot.split('-'),
                    _timeSlot$split6 = (0, _slicedToArray2.default)(_timeSlot$split5, 2),
                    start = _timeSlot$split6[0],
                    end = _timeSlot$split6[1];
                  var timeSlotStart = start.trim();
                  var timeSlotEnd = end.trim();

                  // 判断是否跨天（结束时间小于开始时间）
                  if (timeSlotStart > timeSlotEnd) {
                    // 跨天情况：分为两段 20:00-23:59 和 00:00-06:00
                    data.timeSlots.push({
                      timeSlotStart: timeSlotStart,
                      timeSlotEnd: '23:59'
                    });
                    data.timeSlots.push({
                      timeSlotStart: '00:00',
                      timeSlotEnd: timeSlotEnd
                    });
                  } else {
                    // 非跨天情况：正常处理
                    data.timeSlots.push({
                      timeSlotStart: timeSlotStart,
                      timeSlotEnd: timeSlotEnd
                    });
                  }
                });
              }
              _context4.next = 2;
              return (0, _storeStatistics.getSceneStack)(data);
            case 2:
              response = _context4.sent;
              if (response.code === 200) {
                this.sceneStackData = response.data || {};
                // 数据加载完成后初始化图表
                this.initSceneStackChart();
              } else {
                this.$message.error(response.message || "获取失败");
              }
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](1);
            case 4:
              _context4.prev = 4;
              this.sceneStackLoading = false;
              return _context4.finish(4);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function getSceneStack() {
        return _getSceneStack2.apply(this, arguments);
      }
      return getSceneStack;
    }(),
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return "";
      return parseTime(time, "{y}-{m}-{d} {h}:{i}:{s}");
    },
    // 格式化金额
    formatAmount: function formatAmount(amount) {
      if (!amount && amount !== 0) {
        return '0.00';
      }
      return Number(amount).toFixed(2);
    },
    // 初始化趋势图
    initRevenueAndVolumeChart: function initRevenueAndVolumeChart() {
      var _this = this;
      this.$nextTick(function () {
        var chartDom = _this.$refs.revenueAndVolumeChart;
        if (!chartDom) {
          console.log('图表 DOM 未找到');
          return;
        }
        var _this$revenueAndVolum = _this.revenueAndVolumeData,
          timeSlot = _this$revenueAndVolum.timeSlot,
          y1 = _this$revenueAndVolum.y1,
          y2 = _this$revenueAndVolum.y2;

        // 检查数据是否存在
        if (!timeSlot || timeSlot.length === 0) {
          console.log('数据为空，不初始化图表');
          return;
        }
        console.log('初始化图表，数据:', _this.revenueAndVolumeData);

        // 如果图表已经初始化过，先销毁
        var existingChart = echarts.getInstanceByDom(chartDom);
        if (existingChart) {
          existingChart.dispose();
        }
        var myChart = echarts.init(chartDom);
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['总营业额 (元)', '总订单数 (单)'],
            top: '10px'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: timeSlot || [],
            axisLabel: {
              interval: 0,
              rotate: 45
            }
          },
          yAxis: [{
            type: 'value',
            name: '总营业额 (元)',
            position: 'left',
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          }, {
            type: 'value',
            name: '总订单数 (单)',
            position: 'right',
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              show: false
            }
          }],
          series: [{
            name: '总营业额 (元)',
            type: 'bar',
            yAxisIndex: 0,
            data: y1 || [],
            itemStyle: {
              color: '#6685e8'
            },
            barWidth: '50%'
          }, {
            name: '总订单数 (单)',
            type: 'line',
            yAxisIndex: 1,
            data: y2 || [],
            itemStyle: {
              color: '#eebb68'
            },
            lineStyle: {
              width: 2
            },
            symbol: 'circle',
            symbolSize: 6
          }]
        };
        myChart.setOption(option);

        // 响应窗口大小变化
        window.addEventListener('resize', function () {
          myChart.resize();
        });
      });
    },
    // 初始化场景订单量堆叠柱状图
    initSceneStackChart: function initSceneStackChart() {
      var _this2 = this;
      this.$nextTick(function () {
        var chartDom = _this2.$refs.sceneStackChart;
        if (!chartDom) {
          console.log('场景图表 DOM 未找到');
          return;
        }
        var _this2$sceneStackData = _this2.sceneStackData,
          timeSlot = _this2$sceneStackData.timeSlot,
          dineInCount = _this2$sceneStackData.dineInCount,
          pickUpCount = _this2$sceneStackData.pickUpCount,
          takeoutCount = _this2$sceneStackData.takeoutCount;

        // 检查数据是否存在
        if (!timeSlot || timeSlot.length === 0) {
          console.log('场景数据为空，不初始化图表');
          return;
        }
        console.log('初始化场景图表，数据:', _this2.sceneStackData);

        // 如果图表已经初始化过，先销毁
        var existingChart = echarts.getInstanceByDom(chartDom);
        if (existingChart) {
          existingChart.dispose();
        }
        var myChart = echarts.init(chartDom);
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['堂食', '外卖', '自提'],
            top: '10px'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: timeSlot || [],
            axisLabel: {
              interval: 0,
              rotate: 45
            }
          },
          yAxis: {
            type: 'value',
            name: '订单量',
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          series: [{
            name: '堂食',
            type: 'bar',
            stack: 'total',
            data: dineInCount || [],
            itemStyle: {
              color: '#6685e8'
            },
            barWidth: '50%'
          }, {
            name: '外卖',
            type: 'bar',
            stack: 'total',
            data: takeoutCount || [],
            itemStyle: {
              color: '#3b4a5a'
            },
            barWidth: '50%'
          }, {
            name: '自提',
            type: 'bar',
            stack: 'total',
            data: pickUpCount || [],
            itemStyle: {
              color: '#66d9a8'
            },
            barWidth: '50%'
          }]
        };
        myChart.setOption(option);

        // 响应窗口大小变化
        window.addEventListener('resize', function () {
          myChart.resize();
        });
      });
    }
  },
  created: function created() {
    var _this3 = this;
    this.getStoreStatistics();
    this.getRevenueAndVolumeTrendsData();
    this.getSceneStack();
    (0, _shopList.getEffectiveCityList)({
      regionType: 2
    }).then(function (res) {
      _this3.regionOptions = res.data;
    });
    (0, _shopList.getAreaList)().then(function (res) {
      _this3.areaOptions = res.data;
    });
    (0, _shopList.getStoreData)().then(function (res) {
      _this3.storeList = res.records;
    });
    (0, _shopList.getTimeSlot)().then(function (res) {
      _this3.timeSlotList = res.data;
    });
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁时清除定时器
  },
  mounted: function mounted() {
    // 初始化时获取会员列表数据
  },
  watch: {
    revenueAndVolumeData: {
      handler: function handler() {
        this.initRevenueAndVolumeChart();
      },
      deep: true
    },
    sceneStackData: {
      handler: function handler() {
        this.initSceneStackChart();
      },
      deep: true
    }
  }
};